import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { parse, stringify } from 'query-string';

import { decorateComponent } from '../helpers';
import { PATHS } from '../constants';

const mapStateToProps = ({ user }) => ({
  loggedIn: user.get('loggedIn'),
});

/*
 * Ripped from here: https://reacttraining.com/react-router/web/example/auth-workflow
 */
const BareLoginRequiredRoute = ({ loggedIn, component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      loggedIn === false
        ? (
          <Redirect
            to={{
              pathname: PATHS.LOGIN,
              search: stringify({
                ...parse(props.location.search),
                next: props.location.pathname,
              }),
              state: { from: props.location },
            }}
          />
        )
        : (
          <Component {...props} />
        )
    )}
  />
);

BareLoginRequiredRoute.propTypes = {
  loggedIn: PropTypes.bool,
  component: PropTypes.object,
  location: PropTypes.object.isRequired,
};

const decorators = [
  connect(mapStateToProps),
];
export default decorateComponent(BareLoginRequiredRoute, decorators);
